import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { SharedModule } from '@shared/shared.module';

@Component({
 selector: 'iho-relatedlinks',
 templateUrl: './relatedlinks.component.html',
 styleUrls: ['./relatedlinks.component.scss'],
 standalone: true,
 imports: [CommonModule, SharedModule],
})
export class RelatedlinksComponent {
 @Input() isPdpLinks: any = false;
 @Input() pdpLinks: any = [];
 @Input() dataSource: any;


}
